import React from "react";
import PropTypes from "prop-types";
import Paper from "@material-ui/core/Paper/Paper";
import AppBar from "@material-ui/core/AppBar/AppBar";
import withStyles from "@material-ui/core/styles/withStyles";
import { connect } from "react-redux";

const styles = (theme) => ({
  wrapper: {
    maxWidth: "100%",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    [theme.breakpoints.up("lg")]: {
      minHeight: 800,
    },
    "& header": {
      [theme.breakpoints.down("md")]: {
        backgroundColor: theme.palette.grey[50],
        width: "480px",
        margin: "0 auto",
      },
    },
  },
  headerWrapper: {
    [theme.breakpoints.down("md")]: {
      width: "100%",
      position: "fixed",
      zIndex: 9999,
      backgroundColor: theme.palette.grey[50],
    },
  },
  paper: {
    width: theme.wbiComponent.login.width,
    [theme.breakpoints.down("md")]: {
      boxShadow: "none",
      backgroundColor: theme.palette.grey[50],
      minHeight: "97vh",
    },
  },
  logo: {
    margin: theme.spacing(2, "auto"),
    maxWidth: 140,
    [theme.breakpoints.down("md")]: {
      margin: "0",
      height: 65,
    },
  },
  content: {
    width: "100%", // Fix IE11 issue.
    padding: theme.spacing(2, 4),
  },
  signupContent: {
    [theme.breakpoints.down("md")]: {
      paddingTop: "15%",
    },
  },
  signupWidth: {
    [theme.breakpoints.down("md")]: {
      width: "100%",
    },
  },
});

const CenteredContent = ({
  children,
  classes,
  headerContent,
  isSignup,
  logo,
}) => {
  return (
    <div className={classes.wrapper}>
      <Paper className={`${classes.paper} ${isSignup && classes.signupWidth}`}>
        <div className={isSignup ? classes.headerWrapper : ""}>
          <AppBar position="static" color="default">
            { logo && <img className={classes.logo} src={logo} alt="app logo" /> }
            {headerContent}
          </AppBar>
        </div>
        <div
          className={`${classes.content} ${isSignup && classes.signupContent}`}
        >
          {children}
        </div>
      </Paper>
    </div>
  );
};

CenteredContent.propTypes = {
  children: PropTypes.node.isRequired,
  classes: PropTypes.object.isRequired,
  headerContent: PropTypes.node,
};

const mapStateToProps = (state) => {
  return {
    logo: state.app.logoColored || state.app.logo,
  };
};

export default withStyles(styles)(connect(mapStateToProps)(CenteredContent));



// WEBPACK FOOTER //
// ./src/components/UI/CenteredContent.jsx